import React, { useContext, useEffect, useState } from 'react';

import { FilterContext } from '../../../../Context/FilterContext';
import Modal from '../../../../Modal/Modal';
import PersonalFilter from '../../PersonalFilter/PersonalFilter';
import StandardFilter from '../../StandardFilter/StandardFilter';

import './../Filter.scss';

enum TabSection {
    PERSONAL_FILTER,
    STANDARD_FILTER,
}

interface Props {
    visible: boolean;
    toggleVisibility: () => void;
}

const FilterModal: React.FunctionComponent<Props> = (props) => {
    const [tabSection, updateTabSection] = React.useState<TabSection>(TabSection.PERSONAL_FILTER);
    const { activeSkinAnalysis, standardFilterValues, resetAllFilters } = useContext(FilterContext);

    const [resetTimestamp, updateResetTimestamp] = useState(0);

    useEffect(() => {
        if (activeSkinAnalysis === null && standardFilterValues !== null) {
            updateTabSection(TabSection.STANDARD_FILTER);
        }
    }, [activeSkinAnalysis, standardFilterValues]);

    const reset = (): void => {
        resetAllFilters();
        updateResetTimestamp(new Date().getTime() / 1000);
    };

    const TabElement: React.FunctionComponent<{ section: TabSection }> = (tabElementProps) => {
        const classNames = [
            'filter-overlay__tab-element',
            tabElementProps.section === tabSection ? 'filter-overlay__tab-element--active' : '',
        ];

        return (
            <a className={classNames.join(' ')} onClick={() => updateTabSection(tabElementProps.section)}>
                <svg className="icon icon--controls">
                    <use xlinkHref="#icon-controls" />
                </svg>
                {tabElementProps.children}
            </a>
        );
    };

    return (
        <Modal visible={props.visible} toggleVisibility={props.toggleVisibility} centerHorizontally={true}>
            <div className="filter-overlay">
                <header className="filter-overlay__header">
                    <nav className="filter-overlay__tabs">
                        <TabElement section={TabSection.PERSONAL_FILTER}>
                            <span>Persönlicher Filter</span>
                        </TabElement>
                        <TabElement section={TabSection.STANDARD_FILTER}>
                            <span>Standard Filter</span>
                        </TabElement>
                    </nav>

                    <div className="filter-overlay__controls filter-overlay-controls">
                        <button onClick={reset} type="button" className="filter-overlay-controls__button">
                            <svg className="icon">
                                <use xlinkHref="#icon-undo" />
                            </svg>
                            <span>Filter zurücksetzen</span>
                        </button>
                    </div>
                </header>
                <div className="filter-overlay__content">
                    <PersonalFilter
                        isVisible={tabSection === TabSection.PERSONAL_FILTER}
                        toggleVisibility={props.toggleVisibility}
                    />
                    <StandardFilter
                        isVisible={tabSection === TabSection.STANDARD_FILTER}
                        toggleVisibility={props.toggleVisibility}
                        resetTimestamp={resetTimestamp}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default FilterModal;
